<template>
  <b-modal title="Protocolo de Equipamento" v-model="show" size="xl">
    <div id="formularioDeProtocolo">
      <b-container fluid>
        <!-- :::::::::::::::::::::::::::: HEADER DO PROTOCOLO :::::::::::::::::::::::::::: -->
        <b-row class="mt-2">
          <b-col cols="2">
            <img class="m-2" :src="require('/static/images/logo_sgcq.png')" aria-label="Logomarca do SGCQ" width="160" />
          </b-col>
          <b-col cols="7">
            <h3>NEW ENERGY TECH EIRELI</h3>
            <h6>Serviços Técnicos de Consultória, Projeto, Fabricação, Inspeção de Equipamentos.</h6>
            <h6>BR 304 - Km 50,5 - Zona Rural</h6>
            <h6>Fone: (84) 9 9604-4935 / (84) 9 8740-0525</h6>
          </b-col>
          <b-col cols="3" class="text-right">
            <h6><strong>Número: </strong> {{ getNumber() }}</h6>
            <h6><strong>Data: </strong> {{ moment(saida.data).format("DD/MM/YYYY") }}</h6>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="6">
            <b-form-group label="Cliente:" label-for="cliente" label-cols="3" class="m-1">
              <b-form-input id="cliente" v-model="saida.cliente" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Veículo:" label-for="veic" label-cols="3" class="m-1">
              <b-form-input id="veiculo" v-model="informacoes.veiculo" />
            </b-form-group>
          </b-col>

          <b-col cols="6" class="m-0">
            <b-form-group label="Remetente:" label-for="remet" label-cols="3" class="m-1">
              <b-form-input id="remet" v-model="saida.entregou" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Placa:" label-for="placa" label-cols="3" class="m-1">
              <b-form-input id="placa" v-model="informacoes.placa" />
            </b-form-group>
          </b-col>

          <b-col cols="6" class="m-0">
            <b-form-group label="Destinatário:" label-for="dest" label-cols="3" class="m-1">
              <b-form-input id="dest" v-model="saida.recebeu" />
            </b-form-group>
          </b-col>

          <b-col cols="6" class="m-0">
            <b-form-group label="Nota Fiscal:" label-for="nf" label-cols="3" class="m-1">
              <b-form-input id="nf" v-model="saida.notafiscal" />
            </b-form-group>
          </b-col>

          <b-col cols="6" class="m-0">
            <b-form-group label="Serviço:" label-for="serv" label-cols="3" class="m-1">
              <b-form-input id="serv" v-model="informacoes.servico" />
            </b-form-group>
          </b-col>

          <b-col cols="6" class="m-0">
            <b-form-group label="O. Compra:" label-for="oc" label-cols="3" class="m-1">
              <b-form-input id="oc" v-model="informacoes.oc" />
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>PROTOCOLO DE ENTREGA</strong></h4>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
        <b-table bordered hover small head-variant="light" :items="getSaidaItens" :fields="fields.saidaItemProtocolo">
          <template #cell(acoes)="data">
            <div>
              <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)">
                <b-icon icon="pencil-square" variant="primary"> </b-icon>
              </b-button>
            </div>
          </template>
        </b-table>

        <!-- :::::::::::::::::::::::::::: SISTEMA DE FOTOS :::::::::::::::::::::::::::: -->
        <b-img
          v-if="fotos > 0"
          :src="display[0] == null ? require('/static/images/default.png') : display[0]"
          class="rounded-0 emlinha m-2"
          fluid
        />
        <b-img
          v-if="fotos > 1"
          :src="display[1] == null ? require('/static/images/default.png') : display[1]"
          class="rounded-0 emlinha m-2"
          fluid
        />
        <b-img
          v-if="fotos > 2"
          :src="display[2] == null ? require('/static/images/default.png') : display[2]"
          class="rounded-0 emlinha m-2"
          fluid
        />
        <b-img
          v-if="fotos > 3"
          :src="display[3] == null ? require('/static/images/default.png') : display[3]"
          class="rounded-0 emlinha m-2"
          fluid
        />

        <!-- :::::::::::::::::::::::::::: RODAPE DO PROTOCOLO :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="6" class="text-center">
            <div class="borda-redonda">
              <p><strong>Responsável pelo Envio:</strong></p>
              <b-form-group label="Netech:" label-for="env" label-cols="3" class="m-1">
                <b-form-input id="env" v-model="saida.entregou" />
              </b-form-group>
              <b-form-group label="Assinatura:" label-cols="3" class="m-1">
                <b-form-textarea v-model="informacoes.signA" rows="3"></b-form-textarea>
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="6" class="text-center">
            <div class="borda-redonda">
              <p><strong>Responsável pelo Recebimento:</strong></p>
              <b-form-group label="Cliente:" label-for="env" label-cols="3" class="m-1">
                <b-form-input id="env" v-model="saida.recebeu" />
              </b-form-group>
              <b-form-group label="Assinatura:" label-cols="3" class="m-1">
                <b-form-textarea v-model="informacoes.signB" rows="3"></b-form-textarea>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <template #modal-footer>
      <b-row class="pb-1">
        <b-col cols="4" class="p-0">
          <b-form-select v-model="fotos" :options="options" class="mt-1" />
        </b-col>
        <b-col cols="8" class="p-0">
          <b-form-file
            type="file"
            multiple
            class="text-left mt-1"
            v-model="files"
            placeholder="Solte as fotos aqui .jpg"
            accept=".jpg"
          />
        </b-col>
      </b-row>

      <b-button variant="info" @click="carregar()">Carregar</b-button>
      <b-button variant="primary" v-print="'#formularioDeProtocolo'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import TableFields from "@/tools/TableFields";
import Saida from "@/models/Saida";
import SaidaItem from "@/models/SaidaItem";

export default {
  name: "ModalDeImpressaoDeProtocolo",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      saida: new Saida(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      item: new SaidaItem(0, "", "Novo Item", 0),
      itens: [],
      informacoes: { veiculo: "", placa: "", servico: "", oc: "", signA: "", signB: "" },
      files: [],
      display: [],
      fotos: 0,
      options: [
        { value: 0, text: "sem foto" },
        { value: 1, text: "1 foto" },
        { value: 2, text: "2 fotos" },
        { value: 3, text: "3 fotos" },
        { value: 4, text: "4 fotos" },
      ],
    };
  },

  methods: {
    update() {
      this.entradaSaidaStore.LISTAR_SAIDA_ITENS(this.saida.id).then(() => {
        this.item = new SaidaItem(0, "", "Novo Item", 0);
        this.itens = this.getSaidaItens;
      });
    },

    carregar() {
      let arquivos = [];
      this.files.forEach(function (file, i) {
        const reader = new FileReader();
        const blob = new Blob([file]);
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          arquivos[i] = e.target.result;
        };
      });
      this.display = arquivos;
    },

    getNumber() {
      const data = new Date(this.saida.data);
      let numero = "00" + this.saida.id + "-" + data.getFullYear();
      return numero;
    },

    call(saida) {
      this.show = !this.show;
      this.saida = saida;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const { getSaidaItens } = storeToRefs(entradaSaidaStore);

    return {
      store,
      entradaSaidaStore,
      getSaidaItens,
    };
  },
};
</script>

<style lang="scss" scoped>
.emlinha {
  display: inline-flexbox;
}
.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.6rem;
}
</style>
